import { State } from '../State';
import { getPersistent, getDayStats } from './stats.getters';

/**
 * Stats for IcebreakerMessageSuccess analytics event
 */
export function getIcebreakerStats(
  state: State,
  feature: 'greeting' | 'greeting_bot_invite',
  now: number,
) {
  const absoluteStats = {
    absoluteSequence: getPersistent(state, 'icebreakerAbsoluteSequence', 1),
    daySequence: getDayStats(state, 'icebreakerDaySequence', now),
  };

  if (feature === 'greeting') {
    return {
      ...absoluteStats,
      absoluteFeatureSequence: getPersistent(
        state,
        'icebreakerAbsoluteGreetingSequence',
        1,
      ),
      dayFeatureSequence: getDayStats(
        state,
        'icebreakerDayGreetingSequence',
        now,
      ),
    };
  }

  if (feature === 'greeting_bot_invite') {
    return {
      ...absoluteStats,
      absoluteFeatureSequence: getPersistent(
        state,
        'icebreakerAbsoluteBotInviteSequence',
        1,
      ),
      dayFeatureSequence: getDayStats(
        state,
        'icebreakerDayBotInviteSequence',
        now,
      ),
    };
  }

  return absoluteStats;
}
